<template>
    <div v-if="playlist">
        <div class="description align-center">
            Ships <strong>{{ playlist.order_quantity }}</strong>,
            <strong>{{ playlist.product_preference.size }}.</strong>
            bags of <strong>{{ humanizeGrind(playlist.product_preference.grind) }}</strong>
            coffee every <strong>{{ frequency }}</strong>
            <a v-if="isManager" :href="playlistEditUrl">
                <img src='~workplace/edit-icon.svg' class="edit-icon" alt="Rush">
            </a>
        </div>

        <div :class="{ highlight: drag }">
            <transition name="fade" mode="out-in">
                <draggable v-if="products && !playlist.auto"
                           :list="products"
                           :move="preventMoveToSuggestedList"
                           v-bind="dragOptions"
                           @start="$emit('drag', true)"
                           @end="$emit('drag', false)"
                           @change="onChange"
                           class="playlist-draggable">

                        <playlist-item v-for="(product, index) in products"
                                :playlist="playlist"
                                :product="product"
                                :key="product.id"
                                :first-item="index === 0"
                                :bg-color="product.bgColor"
                                :added-in-playlist="true"
                                :show-price="isManager"
                                :can-control="isManager"
                                :order="index"
                                :tax-rate="taxRate"
                                v-on:fast-track="toggleFastTrack(product.id, index)"
                                @remove="onItemRemoved">
                        </playlist-item>

                        <div v-if="products && products.length === 0 && !playlist.auto && !drag" class="playlist-message">
                            This brew queue is empty.
                            <p v-if="!playlist.paused" class="top-margin-sm">
                                Coffees will be ordered from the team requests.
                            </p>
                        </div>
                </draggable>
                <div v-if="playlist.auto && isManager">
                    <div class="playlist-message">
                        This brew queue is currently <strong class="red-font">automated</strong>.
                    </div>
                    <playlist-item v-for="(product, index) in products"
                                   :playlist="playlist"
                                   :product="product"
                                   :key="product.id"
                                   :first-item="index === 0"
                                   :bg-color="product.bgColor"
                                   :added-in-playlist="true"
                                   :show-price="isManager"
                                   :can-control="isManager"
                                   :order="index"
                                   :tax-rate="taxRate"
                                   v-on:fast-track="toggleFastTrack(product.id, index)"
                                   @remove="onItemRemoved">
                    </playlist-item>
                </div>

            </transition>

        </div>

    </div>
</template>

<script>
    import PlaylistItem from './playlist-item'
    import PlaylistMixin from '../../mixins/playlist-mixin'
    import CoffeeMixin from '../../mixins/coffee-mixin'
    import draggable from 'vuedraggable'
    // Images
    import 'workplace/edit-icon.svg';

    export default {
        components: {
            PlaylistItem,
            draggable
        },
        props: {
            playlist: Object,
            drag: Boolean,
            isManager: Boolean
        },
        data: function() {
            return  {
                products: undefined,
                taxRate: Number,
                customSize: undefined
            }
        },
        computed: {
            frequency () {
                return this.humanizeString(this.playlist.frequency);
            },
            playlistEditUrl() {
                return `/workplace/locations/${this.playlist.location_id}/playlists/${this.playlist.id}/edit`
            },
            dragOptions() {
                return {
                    animation: 200,
                    group: "playlist",
                    ghostClass: "ghost",
                    disabled: false,
                    handle: ".handle",
                    direction: "vertical"
                }
            }
        },
        methods: {
            fetchProducts() {
                this.$api.get('products', {params: { playlistId: this.playlist.id }})
                    .then(res => this.handleProducts(res.data))
                    .catch(console.error)
            },
            handleProducts(data) {
                this.products = data.products;
                this.taxRate = data.tax_rate;
                this.products.forEach((p, index) => p.bgColor = this.getPlaylistItemBackgroundColor(p.id))
            },
            preventMoveToSuggestedList: function(evt) {
                return evt.to.className !== "suggested-list-draggable";
            },
            onChange(evt) {
                if (evt.added) {
                    this.onProductMovedToPlaylist(evt.added.element.id, evt.added.newIndex);
                } else if (evt.moved) {
                    this.onProductMovedToPlaylist(evt.moved.element.id, evt.moved.newIndex);
                }
            },
            onProductMovedToPlaylist(productId, newIndex) {
                this.$api.post('reorder_product', {playlistId: this.playlist.id, productId, sortOrder: newIndex})
                    .then(() => {})
                    .catch(console.error)
            },
            onItemRemoved(productId) {
                this.products = this.products.filter(p => p.id !== productId);

                if (!this.products.length) {
                    this.playlist.repeat = false;
                    this.playlist.force_process_next_batch = false;
                }
                this.$emit('refresh-suggestions');
            },
            clearProducts() {
                this.products = [];
            },
            toggleFastTrack(productId, index) {
                // Turn off fast track only if the product is on the top of the playlist
                if (!this.playlist.force_process_next_batch) {
                    this.playlist.force_process_next_batch = true;
                } else if (index === 0) {
                    this.playlist.force_process_next_batch = false;
                }

                let url = 'fast_track'
                if (this.playlist.auto) {
                    url = 'auto_fast_track'
                }

                this.$api.post(url, { isFastTracked: this.playlist.force_process_next_batch, playlistId: this.playlist.id, productId })
                    .then(() => {
                        //if (this.playlist.force_process_next_batch)
                        this.fetchProducts()
                        this.$emit('refresh-suggestions');
                    })
                    .catch((err) => console.error(err)) // TODO: Toggle back if error
            },
        },
        watch: {
            playlist: function() {
                this.products = undefined;
                this.fetchProducts();
            },
            products: function() {
                if (this.products) {
                    this.$emit('is-empty', this.products.length === 0);
                }
            }
        },
        mixins: [
            PlaylistMixin,
            CoffeeMixin
        ]
    }

</script>

<style scoped>
    .description {
        padding: 1rem 0.5rem;
        color: #E15F60;
        font-size: 1rem;
    }

    .edit-icon {
        width: 1rem;
        height: 1rem;
        position: relative;
        top: -2px;
    }

    .playlist-draggable {
        min-height: 60px;
    }

    .playlist-message {
        padding: 1rem 1rem;
        text-align: center;
    }

    .highlight {
        border: 2px dashed #E15F60;
    }

    .ghost {
        opacity: 0.4;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .7s ease;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
